import React, {useState, useEffect, useCallback, useRef, useLayoutEffect} from 'react';
import ReactHtmlParser, {convertNodeToElement} from "react-html-parser";
import {isMobile, useGlobalState} from "../state";
import {AOJSlider} from "../components/AOJSlider";
import ProductFilters from "../products_list/filters";

export default function DiamondFilters(props) {
    const [filtersHTML] = useState(document.querySelector('#o-filters-block').innerHTML);
    const [dfiltersConfig, setDFiltersConfig] = useGlobalState('dfilters');
    const [byoStep] = useGlobalState('byoStep');
    const [dType, setDType] = useGlobalState('dType');
    const [dShape, setDShape] = useGlobalState('dShape');
    const [isGrid ,setIsGrid] = useGlobalState('isGrid');
    const [BYOSelectedSettingID] = useGlobalState('BYOSelectedSettingID');
    const [canBeSetWith] = useGlobalState('canBeSetWith');

    const [currentHoveredShape, setCurrentHoveredShape] = useState(null);
    const [currentHoveredFancyColor, setCurrentHoveredFancyColor] = useState(null);
    const [moreFiltersExpanded, setMoreFiltersExpanded] = useState(false);
    const [mobileFiltersExpanded, setMobileFiltersExpanded] = useState(false);

    const sliderRefs = useRef(new Map()).current;
    const showMoreFiltersBtnRef = useRef(null);
    const mobileFiltersExpandBtnRef = useRef(null);

    const [slidersRealTimeState, setSlidersRealTimeState] = useState({});
    useLayoutEffect(() => { setSlidersRealTimeState({}); }, [dfiltersConfig])

    useLayoutEffect(() => {
        //set active breadcrumb
        if(document.querySelector('#' + byoStep.replace('detail', '') + '-crumb')) {
            document.querySelector('#' + byoStep.replace('detail', '') + '-crumb').className = 'active';
        }
        //show all filters if one from more is selected
        if(Object.keys(dfiltersConfig).some(filterId => {
            let shouldBeExpanded = false;

            if(['depth', 'table_pct', 'ratio'].includes(filterId)) {
                shouldBeExpanded = dfiltersConfig[filterId]['default_min'] && (dfiltersConfig[filterId].min > dfiltersConfig[filterId]['default_min'] || dfiltersConfig[filterId].max < dfiltersConfig[filterId]['default_max']);
            }
            if(['fluorescence', 'polish', 'symmetry'].includes(filterId)) {
                const values = sliderRefs.get(filterId).node.querySelector('input').value.split(',').map(v => parseInt(v));
                const marks = sliderRefs.get(filterId).marks;
                shouldBeExpanded = values[0] !== marks[0].value || values[1] !== marks[marks.length -1].value
            }
            if(['lab', 'deliverydatedays'].includes(filterId)) {
                shouldBeExpanded = dfiltersConfig[filterId].length > 0
            }
            return shouldBeExpanded;
        })) {
            showMoreFiltersBtnRef.current.click();
            if(isMobile()) {
                mobileFiltersExpandBtnRef.current.click();
            }
        }
        //expand mobile filters if one from more is selected
        if(isMobile() && Object.keys(dfiltersConfig).some(filterId => {
            let shouldBeExpanded = false;

            if(['cut', 'color', 'clarity', 'intensity'].includes(filterId)) {
                const values = sliderRefs.get(filterId).node.querySelector('input').value.split(',').map(v => parseInt(v));
                const marks = sliderRefs.get(filterId).marks;
                shouldBeExpanded = values[0] !== marks[0].value || values[1] !== marks[marks.length -1].value
            }

            return shouldBeExpanded;
        })) {
            mobileFiltersExpandBtnRef.current.click();
        }
    }, [])

    const onDTypeClick = (dtype) => {
        setDType(dtype);
        if(document.querySelector('#diamond-crumb')) {
            document.querySelector('#diamond-crumb h4').innerText = dtype === 'natural' ? "SELECT DIAMOND" : "SELECT LAB DIAMOND"
        }
    }

    const onShapeClick = (shapeId) => {
        if(dShape.includes(shapeId)) {
            setDShape(dShape.split(',').filter((dshape) => dshape !== shapeId).join(','));
        }
        else {
            const dshapeArr = dShape === '' ? [] : dShape.split(',');
            dshapeArr.push(shapeId);
            setDShape(dshapeArr.join(','))
        }
    }

    const onFancyColorClick = (color) => {
        debugger;
        let dFancyColorArr = dfiltersConfig['fancy_color'] ?? [];
        if(dFancyColorArr.includes(color)) {
            dFancyColorArr = dFancyColorArr.filter((dfancycolor) => dfancycolor !== color);
        }
        else {
            dFancyColorArr.push(color);
        }
        setDFiltersConfig({...dfiltersConfig,  ['fancy_color']: dFancyColorArr});
    }

    const onFilterSlide = (filterId, newValue) => {
        setDFiltersConfig({...dfiltersConfig, [filterId]: {...dfiltersConfig[filterId], min: newValue[0], max: newValue[1]}});
    }

    const onFilterInputChange = (event) => {
        const filterId = event.target.getAttribute('filterid'); if(!filterId) return;
        let value = event.target.value === '' ? '' : Number(event.target.value);
        value = value < dfiltersConfig[filterId].default_min ? dfiltersConfig[filterId].default_min : value;
        value = value > dfiltersConfig[filterId].default_max ? dfiltersConfig[filterId].default_max : value;
        setDFiltersConfig({...dfiltersConfig, [filterId]: {...dfiltersConfig[filterId], [event.target.id.replace('slider-input-', '')]: value}});
    }

    const onFilterStepSlide = (filterId, filterMarks, newValue) => {
        const filterValues = filterMarks.filter((mark) => mark.value >= newValue[0] && mark.value <= newValue[1]).map((mark) => {
            switch(mark.label) {
                case 'Excell.': mark.label = 'excellent'; break;
                case 'Very Str.': mark.label = 'very strong'; break;
                case 'None/Neg.': mark.label = 'none'; break;
            }
            return mark.label;
        });
        setDFiltersConfig({...dfiltersConfig, [filterId]: filterValues});
    }

    const onLabClick = (labId) => {
        let labArr = dfiltersConfig['lab'] ?? [];
        if(labArr.includes(labId)) {
            labArr = labArr.filter((lab) => lab !== labId);
        }
        else {
            labArr.push(labId);
        }
        setDFiltersConfig({...dfiltersConfig,  ['lab']: labArr});
    }

    const onDeliveryDateClick = (daysId) => {
        setDFiltersConfig({...dfiltersConfig,  ['deliverydatedays']: daysId === '0' ? [] : [daysId]});
    }

    const onTreatmentClick = (treatment) => {
        setDFiltersConfig({...dfiltersConfig,  ['treatment']: treatment === '' ? [] : [treatment]});
    }

    const onShowMoreFiltersBtnClick = (event) => {
        const moreFiltersWrapper = event.currentTarget.parentNode.parentNode.querySelector('#more');
        moreFiltersWrapper.style.display = !moreFiltersExpanded ? 'block' : 'none';
        setMoreFiltersExpanded(!moreFiltersExpanded);
    }

    const onDisplayTypeClick = (displayType) => {
        setIsGrid()
    }

    const onMobileFiltersToggleBtnClick = (event) => {
        setMobileFiltersExpanded(!mobileFiltersExpanded);
        if(!mobileFiltersExpanded) {
            event.currentTarget.parentNode.parentNode.parentNode.querySelector('#dropdownFilters').style.display = 'initial';
            event.currentTarget.querySelector('#span-expandable').classList.remove('fa-plus');
            event.currentTarget.querySelector('#span-expandable').classList.add('fa-minus');
        }
        else {
            event.currentTarget.parentNode.parentNode.parentNode.querySelector('#dropdownFilters').style.display = 'none';
            event.currentTarget.querySelector('#span-expandable').classList.remove('fa-minus');
            event.currentTarget.querySelector('#span-expandable').classList.add('fa-plus');
        }
    }

    const onMobileDropdownClick = (event) => {
        const dropdown = event.target.nextElementSibling;
        dropdown.style.position = "fixed";
        dropdown.style.bottom = "-100vh";
        dropdown.style.left = "0";
        dropdown.style.right = "0";
        dropdown.style.width = "100%";
        dropdown.style.marginLeft =  "0";
        dropdown.style.zIndex = "1000004";
        dropdown.style.top = "auto";
        dropdown.style.paddingBottom = "32px";
        dropdown.style.paddingLeft = "16px";
        dropdown.style.paddingRight = "16px";
        dropdown.style.transition = "bottom 200ms ease-in-out";
        dropdown.style.maxHeight = "50vh";
        dropdown.style.overflowY =  "auto";
        dropdown.style.overflowX =  "hidden";

        if(dropdown.firstChild.nodeName !== 'DIV') {
            const dropdownHeader = document.createElement('div');
            dropdownHeader.style.display = 'flex';
            dropdownHeader.style.justifyContent = 'space-between';
            dropdownHeader.style.alignItems = 'center';
            dropdownHeader.style.paddingLeft = '16px';
            dropdownHeader.style.paddingRight =  '24px';
            dropdownHeader.innerHTML = `
                    <h3 style="color: #6fbf98;">${dropdown.parentElement.querySelector('button').innerText}</h3>
                    <h3 style="color: #6fbf98; font-size: 35px; cursor:pointer;" onclick="this.parentElement.parentElement.parentElement.classList.remove('open');">×</h3>
                `;
            dropdown.insertBefore(dropdownHeader, dropdown.firstChild);
        }

        requestAnimationFrame(() => {
            dropdown.style.bottom = 0;
        })
    }

    return (
        <div>
            {(dType !== 'gemstone' && dType !== 'naturalfancycolored') &&
                <>
                    {ReactHtmlParser(filtersHTML, {
                        transform: (node) => transformNode(node)
                    })}
                    <div className="container">
                        <div className="well well-sm" style={{marginTop: "2%"}}>
                            <strong>Display</strong>
                            <div className="btn-group diamond-list-grid-btns" style={{marginLeft: "10px"}}>
                                <button onClick={() => setIsGrid(true)} className={"btn btn-default btn-inverse" + (isGrid ? ' btn-inverse-selected' : '')} style={{marginRight: "5px"}}><span className="glyphicon glyphicon-th"></span>Grid</button>
                                <button onClick={() => setIsGrid(false)} className={"btn btn-default btn-inverse" + (!isGrid ? ' btn-inverse-selected' : '')}><span className="glyphicon glyphicon-th-list"></span>List</button>
                            </div>
                        </div>
                    </div>
                </>
            }
            {(dType === 'gemstone' || dType === 'naturalfancycolored') &&
                <ProductFilters/>
            }
        </div>
    )

    function transformNode(node, isChild = false) {
        //dtype
        if(node.type === 'tag' && node.name === 'div' && node.attribs.class && node.attribs.class.includes('dtype-filter')) {
            return <div {...node.attribs} style={{marginBottom: "30px"}}>
                        {node.children.map((child) => {
                            const childEl = transformNode(child, true);
                            if(child.name === 'button' || child.name === 'a') {
                                // console.log(child);
                                childEl.props.className = "btn btn-default btn-inverse" + (dType === child.attribs.dtype ? ' btn-inverse-selected' : '');
                                childEl.props.onClick = () => onDTypeClick(child.attribs.dtype);
                            }
                            return childEl;
                        })}
                   </div>
        }
        //shape
        if(node.type === 'tag' && node.name === 'div' && node.attribs.id && node.attribs.id === 'shape') {
            return <div {...node.attribs}>
                        {node.children.map((child) => {
                            if(child.name === 'img') {
                                const dShapeId = child.attribs.shape.trim().replaceAll(' ', '_').toLowerCase();
                                const shapeId = child.attribs.shape.trim().replaceAll(' ', '-').toLowerCase();
                                return <img {...child.attribs}
                                            style={BYOSelectedSettingID !== '' && canBeSetWith !== '' && !canBeSetWith.toLowerCase().split(',').includes(shapeId) ? {opacity: 0.5, pointerEvents: "none"} : null}
                                            src={`img/diamonds/${shapeId}${dShape.replaceAll('_', '-').includes(shapeId) ? '-hover': ''}.png`}
                                            onClick={() => onShapeClick(dShapeId)}
                                            onMouseEnter={() => setCurrentHoveredShape(dShapeId)}
                                            onMouseLeave={() => setCurrentHoveredShape(null)}
                                       />
                            }
                            if(child.name === 'div' && child.attribs.id === 'shapeHere') {
                                return <div id="shapeHere" style={{textAlign: "center", marginTop: "3%", height: "16px", textTransform: "capitalize"}}>
                                            {currentHoveredShape
                                                ? currentHoveredShape.trim().replaceAll("_", " ")
                                                : dShape.split(',').map((shape) => shape.trim().replaceAll("_", " ")).join(', ')
                                            }
                                       </div>
                            }
                            return null;
                        })}
                   </div>
        }
        //fancycolor
        if(node.type === 'tag' && node.name === 'div' && node.attribs.id && node.attribs.id === 'fancycolor') {
            return <div {...node.attribs} style={{position: "relative"}}>
                {node.children.map((child) => {
                    if(child.name === 'div' && child.attribs.color) {
                        const isSelected = (dfiltersConfig['fancy_color'] ?? []).includes(child.attribs?.color);
                        return <div {...child.attribs}
                                    className={(isSelected ? 'colorBox selectedBox ' : ' notselectedBox ') + child.attribs.class}
                                    style={{float: "left", marginLeft: "1%", marginBottom: "8px", cursor: "pointer"}}
                                    onClick={() => onFancyColorClick(child.attribs.color)}
                                    onMouseEnter={() => setCurrentHoveredFancyColor(child.attribs.color)}
                                    onMouseLeave={() => setCurrentHoveredFancyColor(null)}
                               />;
                    }
                    if (child.name === 'div' && child.attribs.id === 'colorHere') {
                        return <div id="colorHere" style={{textAlign: "center", marginTop: "3%", height: "16px", textTransform: "capitalize", position: "absolute", bottom: "-125px", left: 0, right: 0}}>
                            {currentHoveredFancyColor
                                ? currentHoveredFancyColor.trim().replaceAll("_", " ")
                                : (dfiltersConfig['fancy_color'] ?? []).map((color) => color.trim().replaceAll("_", " ")).join(', ')
                            }
                        </div>
                    }
                    return null;
                })}
            </div>
        }
        //sliders
        if(node.type === 'tag' && node.name === 'div' && node.attribs.class && node.attribs.class.includes('dfilter-slider')) {
            const filterId = node.children[1].attribs.id.toLowerCase().replace('_filter_diamond', '');
            if(!slidersRealTimeState[filterId]) {
                slidersRealTimeState[filterId] = [dfiltersConfig[filterId].min, dfiltersConfig[filterId].max];
            }
            return <div className="col-sm-12 dfilter-slider" ref={node => { return !node ? sliderRefs.delete(filterId): sliderRefs.set(filterId, {node: node});}}>
                      <AOJSlider
                          value={[parseFloat(slidersRealTimeState[filterId][0]), parseFloat(slidersRealTimeState[filterId][1])]}
                          min={dfiltersConfig[filterId]['default_min']} max={dfiltersConfig[filterId]['default_max']}
                          step={parseFloat(node.children[1].attribs['data-slider-step'])}
                          // scale={(x) => x ** (filterId === 'marked_price' ? 10 : 1)}
                          onChange={(_, newValue) => setSlidersRealTimeState(prevState => {return {...prevState, [filterId] : newValue};})}
                          onChangeCommitted={(_, newValue) => onFilterSlide(filterId, newValue)}
                      />
                      <div style={{display: "flex", justifyContent: "space-between"}}>
                        <input filterid={filterId} id='slider-input-min' type="text" pattern="^\d*(\.\d{0,2})?$" value={slidersRealTimeState[filterId][0]} onChange={(event) => setSlidersRealTimeState(prevState => {return {...prevState, [filterId]: [event.target.value, prevState[filterId][1]] };})} onBlur={onFilterInputChange} style={{width: "70px", fontSize: "12px", marginTop: "6px", textAlign: "center"}}/>
                        <input filterid={filterId} id='slider-input-max' type="text" pattern="^\d*(\.\d{0,2})?$" value={slidersRealTimeState[filterId][1]} onChange={(event) => setSlidersRealTimeState(prevState => {return {...prevState, [filterId]: [prevState[filterId][0], event.target.value] };})} onBlur={onFilterInputChange} style={{width: "70px", fontSize: "12px", marginTop: "6px", textAlign: "center"}}/>
                      </div>
                   </div>
        }
        //step-sliders
        if(node.type === 'tag' && node.name === 'div' && node.attribs.class && node.attribs.class.includes('dfilter-step-slider')) {
            const filterId = node.children[1].attribs.id.toLowerCase().replace('_filter_diamond', '');
            const filterMarks = JSON.parse(node.children[1].attribs['data-slider-ticks-labels']).map((label, index) => {
                return {
                    value: index + 1,
                    label: label,
                    isSelected: (dfiltersConfig[filterId]
                        ? dfiltersConfig[filterId].map((value) => value.replace(new RegExp(' ', 'g'), '_').toLowerCase())
                            .includes((() => {
                                switch(label.toLowerCase()) {
                                    case 'excell.': label = 'excellent'; break;
                                    case 'very str.': label = 'very strong'; break;
                                    case 'none/neg.': label = 'none'; break;
                                }
                                return label.replace(new RegExp(' ', 'g'), '_').toLowerCase();
                            })())
                        : true
                )}
            });
            return <div className={node.attribs.class} ref={node => { return !node ? sliderRefs.delete(filterId): sliderRefs.set(filterId, {node: node, marks: filterMarks});}}>
                        <AOJSlider
                            value={[filterMarks.slice().find((mark) => mark.isSelected).value, filterMarks.slice().reverse().find((mark) => mark.isSelected).value]}
                            min={filterMarks[0].value} max={filterMarks[filterMarks.length - 1].value}
                            marks={filterMarks}
                            onChange={(_, newValue) => onFilterStepSlide(filterId, filterMarks, newValue)}
                        />
                   </div>
        }
        //lab
        if(node.type === 'tag' && node.name === 'div' && node.attribs.class && node.attribs.class.includes('dfilter-lab')) {
            return <div {...node.attribs}>
                        {node.children.map((child) => {
                            const childEl = transformNode(child, true);
                            if(child.name === 'button') {
                                const isSelected =
                                    ((!dfiltersConfig['lab'] || dfiltersConfig['lab'].length === 0) && child.attribs.lab === '') || //all
                                    (dfiltersConfig['lab'] && dfiltersConfig['lab'].includes(child.attribs.lab.toLowerCase()))
                                childEl.props.className = "btn btn-default btn-inverse" + (isSelected ? ' btn-inverse-selected' : '');
                                childEl.props.onClick = () => onLabClick(child.attribs.lab.toLowerCase());
                            }
                            return childEl;
                        })}
                   </div>
        }
        //deliverydatedays
        if(node.type === 'tag' && node.name === 'input' && node.attribs['filter-kind'] && node.attribs['filter-kind'] === 'deliveryDate') {
            const el = convertNodeToElement(node);
            el.props.checked =
                ((!dfiltersConfig['deliverydatedays'] || dfiltersConfig['deliverydatedays'].length === 0) && node.attribs.days === '0') || //all
                (dfiltersConfig['deliverydatedays'] && dfiltersConfig['deliverydatedays'].includes(node.attribs.days.toLowerCase()))
            el.props.onClick = () => onDeliveryDateClick(node.attribs.days.toLowerCase());
            return el;
        }
        //treatment
        if(node.type === 'tag' && node.name === 'input' && node.attribs['filter-kind'] && node.attribs['filter-kind'] === 'treatment') {
            const el = convertNodeToElement(node);
            el.props.checked =
                ((!dfiltersConfig['treatment'] || dfiltersConfig['treatment'].length === 0) && node.attribs.treatment === '') || //all
                (dfiltersConfig['treatment'] && dfiltersConfig['treatment'].includes(node.attribs.treatment.toLowerCase()))
            el.props.onClick = () => onTreatmentClick(node.attribs.treatment.toLowerCase());
            return el;
        }
        //more filters
        if(node.type === 'tag' && node.name === 'div' && node.attribs.id && node.attribs.id === 'more') {
            return <div {...node.attribs} style={{display: moreFiltersExpanded ? 'block' : 'none'}}>
                        {node.children.map((child) => transformNode(child, true))}
                   </div>
        }
        //more filters btn
        if(node.type === 'tag' && node.name === 'button' && node.attribs.class && node.attribs.class.includes('showmore')) {
            return <button ref={showMoreFiltersBtnRef} className="btn btn-more-select showmore with-color" onClick={onShowMoreFiltersBtnClick}>SHOW {moreFiltersExpanded ? 'LESS' : 'MORE'}</button>;
        }
        //mobile expand/collapse filters button
        if(node.type === 'tag' && node.name === 'button' && node.attribs.id && node.attribs.id === 'filter_button') {
            return <button {...node.attribs} ref={mobileFiltersExpandBtnRef} style={{marginTop: "20px", zIndex: 100000}} onClick={onMobileFiltersToggleBtnClick}>{node.children.map((child) => convertNodeToElement(child))}</button>
        }
        //mobile open dropdown button
        if(node.type === 'tag' && node.name === 'button' && node.attribs.class && node.attribs.class.includes('dropdown-toggle')) {
            return <button onClick={ isMobile() ? onMobileDropdownClick : null} type="button" class="btn btn-inverse dropdown-toggle" data-toggle="dropdown" aria-expanded="false" style={node.attribs.id === 'delivery-date-days-btn' || node.attribs.id === 'treatment-btn' ? {width: "100%"} : null}>{node.children[0].data} <div class="pull-right"><span class="caret"></span></div></button>
        }

        if(isChild) {
            const el = convertNodeToElement(node);
            if(node.children && !(node.name === 'img' || node.name === 'input')) {
                el.props.children = node.children.map((child) => transformNode(child, true))
            }
            return el;
        }
    }
}
